import { useState } from 'react';
import { TicketCategory } from '../../services/supportTicketApi';
import TicketForm from './TicketForm';

const copy = {
  en: { question: 'Did this solve your problem?', yes: 'Yes', no: 'No', solved: 'Glad we could help.',
    offer: 'You can create a support ticket for further help.', create: 'Create a support ticket' },
  ar: { question: 'هل تم حل مشكلتك؟', yes: 'نعم', no: 'لا', solved: 'يسعدنا أننا تمكنا من مساعدتك.',
    offer: 'يمكنك إنشاء تذكرة دعم للحصول على مزيد من المساعدة.', create: 'إنشاء تذكرة دعم' },
};

// This follow-up starts only at a terminal answer. Yes/No never changes the server's decision tree.
export default function SupportResolution({ language, apiBaseUrl, category, onLockChange }: {
  language: 'ar' | 'en'; apiBaseUrl: string; category: TicketCategory; onLockChange: (locked: boolean) => void;
}) {
  const [stage, setStage] = useState<'question' | 'solved' | 'offer' | 'form'>('question');
  const t = copy[language];
  if (stage === 'solved') return <p role="status">{t.solved}</p>;
  if (stage === 'form') return <TicketForm language={language} apiBaseUrl={apiBaseUrl} category={category}
    onCancel={() => setStage('offer')} onLockChange={onLockChange} />;
  if (stage === 'offer') return <div className="support-resolution"><p>{t.offer}</p>
    <button type="button" onClick={() => setStage('form')}>{t.create}</button></div>;
  return <div className="support-resolution" role="group" aria-label={t.question}>
    <p>{t.question}</p><div className="support-resolution__choices">
      <button type="button" onClick={() => setStage('solved')}>{t.yes}</button>
      <button type="button" onClick={() => setStage('offer')}>{t.no}</button>
    </div>
  </div>;
}
